import { get } from "lodash";
import mediator from "@tvg/mediator";
import tvgConf from "@tvg/conf";

import gtmUtils from "./pathHandlingUtils";

const handleNavigationDataLayerUpdate = (label, origin, url) => {
  const microApp = tvgConf().device === "desktop" ? "Promos" : "non-Microapp";

  mediator.base.dispatch({
    type: "PROMOS_CTA_CLICK",
    payload: {
      gaEventLabel: label,
      module: origin,
      microApp,
      destinationUrl: url
    }
  });
};

const handleSiteClickDataLayerUpdate = (data) => {
  const params =
    data.urlLink.indexOf("?") > -1
      ? gtmUtils.decodeURLParams(data.urlLink)
      : {};
  const promoCode =
    get(params, "promoCode", undefined) || get(params, "promocode", undefined);

  mediator.base.dispatch({
    type: "PROMOS_ALL_CTA_CLICK",
    payload: {
      gaEventAction: get(data, "linkLabel", undefined),
      gaEventLabel: promoCode
    }
  });
};

export default {
  handleNavigationDataLayerUpdate,
  handleSiteClickDataLayerUpdate
};
